// extracted by mini-css-extract-plugin
module.exports = {"stars":"rating-stars_stars__8JqWU","full":"rating-stars_full__TB_W5","half":"rating-stars_half__WdLQb","empty":"rating-stars_empty__97Fus"};